"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "#AB34B0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "instagram_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-29.36 -17.967 8.35)",
    fill: "url(#instagram_svg__b)",
    d: "M-17.967 8.349H25.94v21.783h-43.907z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-12.393 -7.732 -.38)",
    fill: "url(#instagram_svg__c)",
    d: "M-7.732-.379h43.907V12.46H-7.732z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.111,
    cy: 34.59,
    rx: 43.852,
    ry: 31.405,
    transform: "rotate(15.744 12.11 34.59)",
    fill: "url(#instagram_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.229 4.473c1.244-.057 1.64-.07 4.81-.07 3.169 0 3.566.014 4.809.07 1.243.057 2.091.255 2.834.542a5.739 5.739 0 0 1 2.066 1.347 5.698 5.698 0 0 1 1.345 2.065c.288.743.485 1.591.543 2.832.057 1.246.07 1.643.07 4.811 0 3.17-.014 3.566-.07 4.81-.056 1.241-.255 2.09-.543 2.832a5.722 5.722 0 0 1-1.345 2.067 5.721 5.721 0 0 1-2.066 1.345c-.743.288-1.591.486-2.832.543-1.245.057-1.642.07-4.811.07-3.17 0-3.566-.014-4.81-.07-1.24-.056-2.09-.255-2.832-.543a5.725 5.725 0 0 1-2.067-1.345 5.718 5.718 0 0 1-1.346-2.066c-.287-.742-.485-1.59-.542-2.832-.057-1.246-.07-1.643-.07-4.81 0-3.17.014-3.567.07-4.81.056-1.243.255-2.091.542-2.834a5.723 5.723 0 0 1 1.347-2.066 5.719 5.719 0 0 1 2.065-1.346c.742-.287 1.591-.484 2.832-.542h.001Zm9.524 2.1c-1.23-.056-1.599-.068-4.714-.068s-3.484.012-4.715.068c-1.138.052-1.755.242-2.166.402a3.623 3.623 0 0 0-1.342.872 3.619 3.619 0 0 0-.872 1.342c-.16.411-.35 1.029-.402 2.167-.056 1.23-.068 1.6-.068 4.714 0 3.115.012 3.484.068 4.715.052 1.138.242 1.755.402 2.166.187.506.485.966.872 1.342.376.387.836.685 1.342.872.411.16 1.028.35 2.166.402 1.23.056 1.599.068 4.715.068 3.116 0 3.484-.012 4.714-.068 1.138-.052 1.756-.242 2.167-.402a3.623 3.623 0 0 0 1.342-.872c.387-.376.685-.836.872-1.341.16-.412.35-1.03.402-2.167.056-1.23.068-1.6.068-4.715 0-3.115-.012-3.484-.068-4.714-.052-1.138-.242-1.756-.402-2.167a3.623 3.623 0 0 0-.872-1.342 3.62 3.62 0 0 0-1.342-.872c-.411-.16-1.029-.35-2.167-.402ZM14.55 19.667a3.891 3.891 0 0 0 4.242-6.35 3.893 3.893 0 1 0-4.242 6.35ZM11.8 11.83a5.996 5.996 0 1 1 8.48 8.48 5.996 5.996 0 0 1-8.48-8.48Zm11.567-.864a1.419 1.419 0 1 0-1.947-2.064 1.419 1.419 0 0 0 1.947 2.064Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__b",
    x1: 3.986,
    y1: 8.349,
    x2: 3.986,
    y2: 30.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#6E3CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E4EBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__c",
    x1: 14.221,
    y1: -0.379,
    x2: 14.221,
    y2: 12.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#2E9FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E4EBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 31.4051 -43.8522 0 12.11 34.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FED77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FED17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#F3883A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F35F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#E23962",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D53085",
    stopOpacity: 0
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInstagram);
var _default = exports["default"] = Memo;